export default "__VITE_ASSET__6igaGARiwlftcQdq_GddPw__"